import React from "react";

// ===================================================================
// The Crowd v2 — Icones
//
// Icones au trait (viewBox 16x16), couleur heritee du texte. Remplacent
// les emojis de l'interface actuelle. Decoratives par defaut
// (aria-hidden) : le libelle accessible est porte par le bouton.
// ===================================================================

const TRACES = {
  dossier: "M2.2 4.4h4l1.2 1.5h6.4v6.4H2.2Z",
  dossierOuvert: "M2.2 12.3V4.4h4l1.2 1.5h5.2v1.6M2.2 12.3l1.6-4.8h10l-1.6 4.8Z",
  fichier: "M4 2.6h5l3 3v7.8H4ZM9 2.6v3h3",
  chevronDroite: "M6 3.5 10.5 8 6 12.5",
  chevronBas: "M3.5 6 8 10.5 12.5 6",
  retour: "M10 3.5 5.5 8l4.5 4.5",
  crayon: "M10.6 2.8l2.6 2.6-7.6 7.6H3v-2.6ZM9.2 4.2l2.6 2.6",
  corbeille: "M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 8.5h5.8l.6-8.5",
  televerser: "M8 10.5V3M4.8 6.2 8 3l3.2 3.2M3 12.5h10",
  plus: "M8 3.5v9M3.5 8h9",
  tableau: "M2.8 2.8h4.4v4.4H2.8ZM8.8 2.8h4.4v4.4H8.8ZM2.8 8.8h4.4v4.4H2.8ZM8.8 8.8h4.4v4.4H8.8Z",
  liste: "M3 4.5h1.5M3 8h1.5M3 11.5h1.5M6.5 4.5H13M6.5 8H13M6.5 11.5H13",
  referentiel: "M3 3h3.2v10H3ZM7.4 3h3.2v10H7.4ZM11.6 3.6l2.2.6-2.4 9.2-2.2-.6",
  lien: "M6.8 9.2a2.6 2.6 0 0 0 3.7 0l2-2a2.6 2.6 0 0 0-3.7-3.7l-.6.6M9.2 6.8a2.6 2.6 0 0 0-3.7 0l-2 2a2.6 2.6 0 0 0 3.7 3.7l.6-.6",
  image: "M2.6 3.4h10.8v9.2H2.6ZM2.6 10.4l3-3 2.6 2.6 1.6-1.6 3.6 3.6M10.2 6a.8.8 0 1 0 0-.1",
  annuler: "M4.5 6.5h5.5a3 3 0 0 1 0 6H7M6.5 4 4 6.5 6.5 9",
  refaire: "M11.5 6.5H6a3 3 0 0 0 0 6h3M9.5 4 12 6.5 9.5 9",
};

function IconeV2({ nom, taille = 14, className = "" }) {
  const d = TRACES[nom];
  if (!d) return null;
  return (
    <svg
      className={`v2-icone ${className}`}
      width={taille}
      height={taille}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  );
}

export default IconeV2;
